/* eslint-disable import/prefer-default-export */
import axios, { AxiosResponse } from 'axios'
import { getShop, getShopLocale } from '@helpers/env'
import {
  Carriers,
  CreateReturnProduct,
  ReboundCustomerAddress,
  ReboundOrder
} from './types'

// eslint-disable-next-line prefer-destructuring
const RETURNS_API_DOMAIN = process.env.RETURNS_API_DOMAIN
const SHOP = getShop()
const REQUEST_HEADERS = {
  headers: {
    'x-api-key': process.env.RETURNS_API_KEY
  }
}

type GetOrderDataArgs = {
  order_name: string
  postcode: string
  admin: boolean
}
export function getOrderData(
  requestBody: GetOrderDataArgs
): Promise<ReboundOrder> {
  const params = new URLSearchParams({
    order_name: `#${requestBody.order_name}`,
    postcode: requestBody.postcode,
    ...(requestBody.admin ? { admin: 'true' } : {})
  })

  const requestUrl = `${RETURNS_API_DOMAIN}/v2/order/${SHOP}?${params.toString()}`

  return axios.get(requestUrl, REQUEST_HEADERS).then(({ data }) => data)
}

export async function getCarriersAvailable(
  orderNumber: string
): Promise<Carriers> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/return/${SHOP}/carrier-services?order_number=${orderNumber}&country=${getShopLocale()}`
  const { data } = await axios.get(reboundRequestUrl, REQUEST_HEADERS)

  if (data.error) {
    throw new Error(data.error)
  }

  if (!data.carriers?.length) {
    throw new Error('No carriers returned')
  }

  return data.carriers
}

type CreateReturnArgs = {
  carrierServiceId: string
  customerAddress: ReboundCustomerAddress
  orderName: string
  returnedProducts: CreateReturnProduct[]
  salesOrderId: string
}

type CreateReturnResponse = {
  message: string
  returnId: string
  labels: {
    id: string
    labelUrl: string
  }[]
}
export function createReturn(
  returnInput: CreateReturnArgs
): Promise<AxiosResponse<CreateReturnResponse>> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/v2/return/${SHOP}`

  return axios.post(reboundRequestUrl, returnInput, REQUEST_HEADERS)
}

type GetReturnStatusResponse = {
  status?: {
    date: string
  }
  error?: {
    message: string
  }
}
export function getReturnStatus(): Promise<
  AxiosResponse<GetReturnStatusResponse>
> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/return/status`
  const res = axios.get(reboundRequestUrl, REQUEST_HEADERS)
  return res
}
